// Open/closed state of collapsible lists, kept in sessionStorage so Back returns to the same view.
// Storage can be missing or throw (private windows, blocked site data); the lists then just use their defaults.

const PREFIX = 'toggles:';

export function readToggles(key: string | undefined): Record<string, boolean> {
  if (!key) return {};
  try {
    const raw = window.sessionStorage.getItem(PREFIX + key);
    const parsed: unknown = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}

export function writeToggles(key: string | undefined, value: Record<string, boolean>): void {
  if (!key) return;
  try {
    window.sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // Not remembered; the list still works.
  }
}
